import React from "react";
import { getStatusInfo } from "../utils/diagnosticHelpers";

/**
 * Form List View Component
 * Shows all assigned diagnostic forms
 */
const FormListView = ({ assignments, onSelect }) => {
  if (!assignments || assignments.length === 0) {
    return (
      <div className="diagnostic-card">
        <div className="empty-state">
          <h3>No Diagnostic Forms Assigned</h3>
          <p>You don't have any diagnostic forms assigned to you yet.</p>
          <p className="empty-hint">
            Your administrator will assign diagnostic forms when needed.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="assignments-grid">
      {assignments.map((assignment) => {
        const status = getStatusInfo(assignment);
        const isCompleted = assignment.submission?.status === "submitted";
        const hasTemplate = !!assignment.template;
        const isPendingApproval = !hasTemplate;

        return (
          <div key={assignment._id} className={`assignment-card ${isPendingApproval ? 'pending-approval' : ''}`}>
            <div className="assignment-header">
              <h3 className="assignment-title">
                {assignment.template?.title || "Diagnostic Form"}
              </h3>
              <span className={`evaluation-badge ${assignment.evaluationType}`}>
                {assignment.evaluationType === "self"
                  ? "Self Evaluation"
                  : "Colleague Evaluation"}
              </span>
            </div>

            {assignment.evaluationType === "colleague" && (
              <p className="target-info">
                Evaluating: {assignment.target?.firstName}{" "}
                {assignment.target?.lastName}
              </p>
            )}

            <p className="assignment-desc">
              {isPendingApproval
                ? "Waiting for admin to approve and assign a form."
                : assignment.template?.description || "Complete this diagnostic assessment."}
            </p>

            <div className="assignment-meta">
              <span className={`status-badge ${isPendingApproval ? 'pending' : status.className}`}>
                {isPendingApproval ? "Pending Approval" : status.label}
              </span>
              {assignment.deadline && (
                <span className="deadline">
                  Due: {new Date(assignment.deadline).toLocaleDateString()}
                </span>
              )}
            </div>

            {isPendingApproval ? (
              <button className="start-btn disabled" disabled>
                Awaiting Admin
              </button>
            ) : (
              <button
                className="start-btn"
                onClick={() => onSelect(assignment)}
              >
                {isCompleted
                  ? "Completed ✓"
                  : assignment.submission?.status === "draft"
                  ? "Continue →"
                  : "Start →"}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FormListView;
